//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, inject } from '@angular/core';
import { firstValueFrom, map, timestamp } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { AdminService } from 'src/app/Services/Global/Admin/admin.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { FilterUserPipe } from '../.././../../Pipes/Admin/filter-user.pipe'
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_User_CDMS, Update_User } from 'src/app/Interfaces/Admin/Data_User_CDMS.interface';
import { Response_Admin } from 'src/app/Interfaces/Admin/Response_Admin.interface';



@Component({
  selector: 'app-adminn-usersof-cdms',
  templateUrl: './adminn-usersof-cdms.component.html',
  styleUrls: ['./adminn-usersof-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
  standalone: false
})

export class AdminnUsersofCDMSComponent implements OnInit {

  //-===================================== SECTION FORMS =====================================-\\

  //+===================== FORM ADD NEW FOLDER =====================+\\
  public Form_Update_User: FormGroup = new FormGroup({
    ID: new FormControl(0, [Validators.required, Validators.pattern(/\d+/)]),
    Name: new FormControl('', [Validators.required, Validators.pattern(/^[^\\/:*?"<>|]*$/), Validators.minLength(5)]),
    Mail: new FormControl('', [Validators.required, Validators.email]),
    LoginName: new FormControl(''),
    Password: new FormControl('')
  })

  //-======================= FORM ADD NEW USER =======================-\\

  public formCreateUser: FormGroup = new FormGroup({
    Nombre: new FormControl('', [Validators.required]),
    LoginName: new FormControl('', [Validators.required]),
    Idioma: new FormControl('es', []),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    passwordConfirm: new FormControl('', [Validators.required, Validators.minLength(8)]),
    found: new FormControl(false, [])
  })


  //+================== VARIABLES GLOBAL FILES FIN ==================+\\
  public All_Users: Data_User_CDMS[] = [];
  public All_Users_Copy: Data_User_CDMS[] = [];
  public All_Users_Copy_Table: Data_User_CDMS[] = [];
  public All_Users_Copy_Search: Data_User_CDMS[] = [];

  //+================== VARIABLES FOR HEADERS USERS ==================+\\
  public Headers_Users: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAMEU' },
    { ID: 1, Name: 'Correo electrónico', Position: 1, Visible: true, Key_Header: 'EMAIL' },
    { ID: 1, Name: 'Login name', Position: 1, Visible: true, Key_Header: 'LOGIN' },
    { ID: 1, Name: 'Fecha de modificación', Position: 1, Visible: true, Key_Header: 'DATEM' },
    { ID: 1, Name: 'Opciones', Position: 1, Visible: true, Key_Header: 'OPTIO' },
  ];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Input_Search: string = '';
  public Input_Search_Table: string = '';
  public Input_Search_Username: string = '';

  //+================== VARIABLES FOR PAGINATION ==================+\\
  public first: number = 0;
  public rows: number = 12;


  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;
  public isList: boolean = true;

  //-========================= SERVICES =========================-\\
  private Service_Admin = inject(AdminService);

  constructor() { }


  ngOnInit(): void {
    this.Load_Component();
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResUsers: Response_Admin = await firstValueFrom(this.Service_Admin.Get_All_Users_CDMS());

      if (ResUsers.success) {

        this.All_Users = ResUsers.operation;

        this.All_Users_Copy = this.All_Users.slice(this.first, this.first + this.rows)

        Loader.classList.remove('active');
        this.LoadPage = true;
      } else {
        throw ResUsers.message;
      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Usuarios)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\





  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\


  //-================== FUNCTTION FORMAT DATE ==================-\\
  public Date_Format(Date_Modification: Date): string {
    return moment(Date_Modification).utc().format('DD/MM/YYYY')
  }

  //-================== FUNCTTION FOR FORMAT MAIL ==================-\\
  public Format_Mail(Mail: string): string {
    return Mail.trim() === '' ? 'Sin Correo' : Mail.trim();
  }

  //-================== FUNCTTION FOR FORMAT LOGIN NAME ==================-\\
  public Format_LoginName(LoginName: string): string {
    return LoginName.trim() === '' ? '---' : LoginName.trim();
  }

  //-================== FUNCTTION FOR INITIALS CARD ==================-\\
  public Format_Initials(Name: string): string {
    let Initials: string = '';
    let NameSplit: string[] = Name.split(' ');

    Initials += NameSplit[0][0] || '?';
    NameSplit.length > 1 ? Initials += NameSplit[1][0] || '' : Initials += NameSplit[0][1] || '';

    return Initials;
  }

  //-================== FUNCTTION FOR ADD CLASS IF EXIST MAIL ==================-\\
  public ContainMail(Mail: string): string {
    return Mail.trim() === '' ? 'Not-Mail' : 'Mail';
  }

  //-================== FUNCTTION FOR PAGINATION ==================-\\
  public onPageChange(event: any): void {

    this.first = event.first;
    this.rows = event.rows;

    this.All_Users_Copy = this.Input_Search.length < 2 ? this.All_Users.slice(event.first, event.first + event.rows) : this.All_Users_Copy_Search.slice(event.first, event.first + event.rows);

  }

  //-================ FUNCTION FOR VALIDATE SEARCH ================-\\
  public Search_Validate(): void {

    if (this.Input_Search.length < 2) {
      Swal.fire({
        title: 'búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_User();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_Enter($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate() : 0;
  }

  //-================== FUNCTTION FOR SEARCH USER ==================-\\
  public Search_User(): void {
    this.Input_Search == '' || this.Input_Search.length < 2 ? this.All_Users_Copy = this.All_Users.slice(this.first, this.first + this.rows) : (this.All_Users_Copy_Search = new FilterUserPipe().transform(this.All_Users, this.Input_Search), this.All_Users_Copy = this.All_Users_Copy_Search.slice(this.first, this.first + this.rows));
  }

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL OPTIONS OF USER ==================-\\
  public Toggle_Modal_Option(Position: number): void {
    const Card_Option = document.getElementById(`Card_Option${Position}`) as HTMLElement;
    Card_Option.classList.toggle('active')
  }

  //-================== FUNCTTION FOR RELOAD PAGE ==================-\\
  public Reload_Page(): void {
    this.Load_Component();
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\





  //&===================== FUNCTIONS FOR UPDATE USER =====================&\\

  //-================== FUNCTTION FOR OPEN AND CALL FILL USER ==================-\\
  public Update_Data_User(User: Data_User_CDMS): void {
    this.Form_Update_User.reset();
    const IsFill: boolean = this.Fill_Form(User);

    if (IsFill) {

      this.Toggle_Modal_Update_User(true);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Vuelva a intentarlo, si el problema persiste notifique a su supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    }

  }

  //-================== FUNCTTION FOR FILL DATA USER ==================-\\
  private Fill_Form(User: Data_User_CDMS): boolean {

    this.Form_Update_User.controls['ID'].setValue(User.ID);
    this.Form_Update_User.controls['Name'].setValue(User.Nombre.trim());
    this.Form_Update_User.controls['Mail'].setValue(User.email.trim());
    this.Form_Update_User.controls['LoginName'].setValue(User.LoginName.trim());
    this.Form_Update_User.controls['Password'].setValue('');
    return true;

  }

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL UPDATE USER ==================-\\
  public Toggle_Modal_Update_User(Close_Or_Open: boolean): void {
    const Modal_Update_User = document.getElementById('Modal_Update_User') as HTMLElement;
    Close_Or_Open ? Modal_Update_User.classList.add('active') : Modal_Update_User.classList.remove('active');
  }

  //-================== FUNCTTION FOR VALIDATE UPDATE USER ==================-\\
  private Validate_Form_Update(): boolean {

    const Idinput_Name_Update = document.getElementById('Idinput_Name_Update') as HTMLInputElement;
    const Idinput_Mail_Update = document.getElementById('Idinput_Mail_Update') as HTMLInputElement;


    if (!this.Form_Update_User.controls['ID'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'ID no valido',
        text: '¡Informe a su supervisor este error!',
        confirmButtonColor: this.ColorConfirm
      });

      return false;
    }


    if (!this.Form_Update_User.controls['Name'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Nombre no valido',
        text: '¡El nombre es muy corto!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Name_Update.classList.add('ng-invalid'); Idinput_Name_Update.classList.add('ng-touched');
      return false;
    }

    if (!this.Form_Update_User.controls['Mail'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Correo no valido',
        text: '¡Inserte un correo electrónico valido!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Mail_Update.classList.add('ng-invalid'); Idinput_Mail_Update.classList.add('ng-touched');
      return false;
    }

    return true;

  }

  //-================== FUNCTTION FOR SAVED USER ==================-\\
  public Saved_User(): void {

    const IsValidForm: boolean = this.Validate_Form_Update();

    if (this.Form_Update_User.valid && IsValidForm) {

      Swal.fire({
        title: '¿Los datos son correctos?',
        text: "Si todo esta bien, presiona el botón para continuar",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
        cancelButtonText: 'No, Cancelar',
      }).then((async result => {

        if (result.isConfirmed) {

          try {

            const password: string =
              (this.Form_Update_User.controls['Password'].value || '')
                .replace(/\s/g, '');

            if (password !== '' && password.length < 8) {

              Swal.fire({
                icon: 'warning',
                title: 'Contraseña no valida',
                text: '¡La contraseña debe tener mínimo 8 caracteres!',
                confirmButtonColor: this.ColorConfirm
              });

              return;
            }

            const Update_User: Update_User = {
              ID: this.Form_Update_User.controls['ID'].value,
              Name: this.Form_Update_User.controls['Name'].value.trim(),
              Mail: this.Form_Update_User.controls['Mail'].value.trim(),
              LoginName: this.Form_Update_User.controls['LoginName'].value.trim(),
              ...(password ? { Password: password } : {})
            }

            console.log(Update_User);

            const ResUpdateUser: Response_Admin = await firstValueFrom(this.Service_Admin.Update_User_CDMS(Update_User));


            if (ResUpdateUser.success) {
              Swal.fire({
                title: 'Usuario modificado',
                text: '¡El usuario se modificó correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              });
              this.Load_Component();
              this.Toggle_Modal_Update_User(false);
            }


          } catch (e) {

            Swal.fire({
              title: 'Error al modificar al usuario',
              text: '¡Error al modificar las propiedades del usuario, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            });
            this.Load_Component();
            this.Toggle_Modal_Update_User(false);

          }

        }

      }))
    }
  }

  //&===================== END FUNCTIONS FOR UPDATE USER =====================&\\





  //&===================== FUNCTIONS FOR DELETE USER =====================&\\

  //-================== FUNCTTION FOR DELETE USER ==================-\\
  public Delete_User(User: Data_User_CDMS): void {

    const NameDelete: string = User.Nombre.trim();


    Swal.fire({
      title: '¿Está seguro de eliminar el usuario del sistema?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar el usuario escriba el nombre ${NameDelete} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {


              try {

                const Res_Delete_User: Response_Admin = await firstValueFrom(this.Service_Admin.Delete_User_CDMS({ ID: User.ID }))

                if (Res_Delete_User.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Usuario eliminado',
                    text: '¡Se eliminó correctamente el usuario!',
                    confirmButtonColor: this.ColorConfirm
                  })
                  this.Load_Component();
                } else {
                  throw Res_Delete_User.message;
                }


              } catch (error) {
                Swal.fire({
                  title: 'Ocurrió un error',
                  text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del usuario para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }
  //&===================== END FUNCTIONS FOR DELETE USER =====================&\\

  //-================== FUNCTTION FOR OPEN MODAL TO ADD USER ==================-\\
  public Toggle_Modal_Add_User(Close_Or_Open: boolean): void {
    const Modal_Add_User = document.getElementById('Modal_Add_User') as HTMLElement;
    Close_Or_Open ? Modal_Add_User.classList.add('active') : Modal_Add_User.classList.remove('active');
    this.ResetUserForModal()
  }

  //-================ FUNCTION FOR VALIDATE SEARCH USERNAME ================-\\
  public Search_Validate_Username(): void {

    if (this.Input_Search_Username.length < 2) {
      Swal.fire({
        title: 'búsqueda no valida',
        text: '¡La búsqueda es muy corta, mínimo 2 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.ResetUserForModal()
      this.Search_Username();
    }

  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER ================-\\
  public Search_Enter_Username($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate_Username() : 0;
  }

  //-================== FUNCTTION FOR SEARCH USER ==================-\\
  public async Search_Username(): Promise<void> {
    // Search user

    try {

      const responseAD: Response_Admin = await firstValueFrom(this.Service_Admin.Search_Username(this.Input_Search_Username));

      if (responseAD.success && responseAD.operation.success) {
        const user = responseAD.operation.user;

        this.formCreateUser.controls['Nombre'].enable();
        this.formCreateUser.controls['email'].enable();
        this.formCreateUser.controls['Nombre'].setValue(user.Nombre);
        this.formCreateUser.controls['email'].setValue(user.email);
        this.formCreateUser.controls['LoginName'].setValue(this.Input_Search_Username);
        this.formCreateUser.controls['found'].setValue(true);

        this.formCreateUser.updateValueAndValidity()

        Swal.fire({
          title: 'Operación Exitosa',
          html: `El usuario <b>${this.Input_Search_Username}</b> se encontró en el sistema. <br> Para darlo de alta en CDMS asegurese de que los campos esten correctos.`,
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: this.ColorConfirm
        });
      } else {
        Swal.fire({
          title: 'Operación Fallida',
          html: 'No se encontró el nombre de usuario en el Active Directory',
          icon: 'warning',
          confirmButtonText: 'Ok',
          confirmButtonColor: this.ColorConfirm
        });
      }

    } catch (error: any) {
      let message = 'Ocurrio un error inesperado, intentelo más tarde!';

      if (error.status) {
        if (error.status === 404) message = `El usuario <b>${this.Input_Search_Username}</b> no se encontró en el sistema. <br> Verifique que este bien escrito he intentelo de nuevo.`;
      }

      Swal.fire({
        title: 'Operación Fallida',
        html: message,
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor: this.ColorConfirm
      });
    }
  }

  public ResetUserForModal() {
    this.formCreateUser.reset();
    this.formCreateUser.controls['Nombre'].setValue('');
    this.formCreateUser.controls['email'].setValue('');
    this.formCreateUser.controls['password'].setValue('');
    this.formCreateUser.controls['passwordConfirm'].setValue('');
    this.formCreateUser.controls['LoginName'].setValue('');
    this.formCreateUser.controls['Idioma'].setValue('es');
    this.Input_Search_Username = '';
  }

  public async addUser() {
    //Enter missing information

    const isValidForm: boolean = this.validateFormCreate();

    if (isValidForm) {

      const formValues = this.formCreateUser.getRawValue();
      const payload = {
        Nombre: formValues.Nombre,
        LoginName: formValues.LoginName,
        email: formValues.email,
        Idioma: formValues.Idioma || 'es',
        Password: formValues.password
      };

      const response: Response_Admin = await firstValueFrom(this.Service_Admin.Add_New_User(payload));

      if (response.success) {
        Swal.fire({
          title: 'Operación Exitosa',
          html: `El usuario <b>${formValues.Nombre}</b> fué agregado exitosamente en el sistema.`,
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: this.ColorConfirm
        }).then((result) => {
          if (result.isConfirmed) {
            this.Toggle_Modal_Add_User(false);
            this.ResetUserForModal();
            this.Load_Component();
          }
        });
      }
      else {
        Swal.fire({
          title: 'Operación Fallida',
          html: `Ocurrió un error inesperado al agregar el usuario <b>${formValues.Nombre}</b> al sistema. <br/> Intentelo de nuevo mas tarde, si el problema persiste, contacte un administrador`,
          icon: 'error',
          confirmButtonText: 'Ok',
          confirmButtonColor: this.ColorConfirm
        }).then((result) => {
          if (result.isConfirmed) {
            this.Toggle_Modal_Add_User(false);
            this.ResetUserForModal();
          }
        });
      }
    } else {

    }
  }

  private validateFormCreate(): boolean {

    const Idinput_Name_Create = document.getElementById('Idinput_Name_Create') as HTMLInputElement;
    const Idinput_Mail_Create = document.getElementById('Idinput_Mail_Create') as HTMLInputElement;
    const Idinput_Password_Create = document.getElementById('Idinput_Password_Create') as HTMLInputElement;


    if (!this.formCreateUser.controls['Nombre'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Nombre no valido',
        text: '¡El nombre es requerido!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Name_Create.classList.add('ng-invalid'); Idinput_Name_Create.classList.add('ng-touched');
      return false;
    }

    if (!this.formCreateUser.controls['email'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Correo no valido',
        text: '¡Inserte un correo electrónico valido!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Mail_Create.classList.add('ng-invalid'); Idinput_Mail_Create.classList.add('ng-touched');
      return false;
    }

    if (!this.formCreateUser.controls['password'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Contraseña no valida',
        text: '¡La contraseña debe tener mínimo 8 caracteres!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Password_Create.classList.add('ng-invalid'); Idinput_Password_Create.classList.add('ng-touched');
      return false;
    }

    const Idinput_Password_Confirm_Create = document.getElementById('Idinput_Password_Confirm_Create') as HTMLInputElement;

    if (!this.formCreateUser.controls['passwordConfirm'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Confirmación de contraseña no valida',
        text: '¡La confirmación de contraseña debe tener mínimo 8 caracteres!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Password_Confirm_Create.classList.add('ng-invalid'); Idinput_Password_Confirm_Create.classList.add('ng-touched');
      return false;
    }

    if (this.formCreateUser.controls['password'].value !== this.formCreateUser.controls['passwordConfirm'].value) {
      Swal.fire({
        icon: 'warning',
        title: 'Contraseñas no coinciden',
        text: '¡La contraseña y la confirmación deben ser iguales!',
        confirmButtonColor: this.ColorConfirm
      });
      Idinput_Password_Create.classList.add('ng-invalid'); Idinput_Password_Create.classList.add('ng-touched');
      Idinput_Password_Confirm_Create.classList.add('ng-invalid'); Idinput_Password_Confirm_Create.classList.add('ng-touched');
      return false;
    }

    return true;
  }
}
